import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SvgIconProps } from "@mui/material/SvgIcon";

export function ChevronDown(props: SvgIconProps) {
  return <ExpandMoreIcon fontSize="small" {...props} />;
}
